import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSnackbar } from '../contexts/SnackbarProvider';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button
} from '@mui/material';
import { accountFields } from '../utils/fields';
import axiosInstance from '../utils/axiosInstance';

const BankAccountDialog = ({ open, onClose, account, onSaved }) => {
    const { showSnackbar } = useSnackbar();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    useEffect(() => {
        if (open) {
            reset(account || {});
        }
    }, [account, open, reset]);
    const handleSave = async (data) => {
        try {
            let res;
            if (account?.invoice_id) {
                // 編集
                res = await axiosInstance.put(
                    `/setting/invoice/bank_account/${account.invoice_id}`,
                    data
                );
            } else {
                // 新規
                res = await axiosInstance.post(
                    '/setting/invoice/bank_account',
                    data
                );
            }

            showSnackbar('口座情報を保存しました', 'success');
            onSaved(res.data);
            onClose();

        } catch (err) {
            if (process.env.NODE_ENV === 'development') {
                console.error(err);
            }
            showSnackbar(err?.response?.data?.message || '口座の保存に失敗しました', 'error');
        }
    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>口座情報</DialogTitle>
            <form onSubmit={handleSubmit(handleSave)}>
                <DialogContent>
                    {accountFields.map(f => (
                        <TextField
                            key={f.name}
                            {...register(f.name, f.validation)}
                            label={f.label}
                            margin="dense"
                            error={!!errors?.[f.name]}
                            helperText={errors?.[f.name]?.message}
                            inputProps={{ maxLength: f.maxLength }}
                        />
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>キャンセル</Button>
                    <Button type="submit" variant="contained">保存</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
export default BankAccountDialog;
